export default class TeamMemberDetailController {
    constructor($scope, $ionicLoading, $state, $stateParams, ApiTeam, ApiSelections) {
        this.$scope = $scope;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.memberId = $stateParams.memberId;
        this.isGroupAdmin = false;
        this.ApiTeam = ApiTeam;
        this.ApiSelections = ApiSelections;
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 10000
        });

        var teamPromises = [];
        var teamMemberPromise = this.ApiTeam.getTeamMember(this.memberId).then((res) => {
            if (typeof res != 'undefined') {
                this.member = res;
            }
        }).then(() => {
          this.ApiTeam.getTeams().then((res) => {
            if (typeof res != 'undefined') {
              this.member.adminOfGroup = res.groupAdminId == this.memberId;
            }
          });
        });
        teamPromises.push(teamMemberPromise);

        var selectionsPromise = this.ApiSelections.getSelectionsOfUser(this.memberId).then((res) => {
            this.selections = res;
        });
        teamPromises.push(selectionsPromise);

        var groupAdminPromise = this.ApiTeam.isGroupAdmin().then((res) => {
            if (typeof res != 'undefined') {
                this.isGroupAdmin = res;
            }
        });
        teamPromises.push(groupAdminPromise);

        Promise.all(teamPromises).then((res) => {
          this.$ionicLoading.hide();
        });
    }

    removeTeamMember(email) {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        this.ApiTeam.removeTeamMember(email).then((result) => {
            this.$ionicLoading.hide();
            this.$state.go('teamDetail', {}, {reload:true});
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/team/teamMemberDetail.controller.js
 **/